export function isPermanentStockCommandRejection(message: string | null): boolean {
  if (!message) return false;
  return /^Operazione magazzino rifiutata \([^)]+\): stock_command_v1_/i.test(
    message.trim(),
  );
}
